import { Button, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputAdornment from "@mui/material/InputAdornment";
import { useResetPassword } from "../../../Hooks/Auth/useResetPassword";
import BackgroundCarousel from "../../../layout/BackgroundCarousel";

const Resetpass = () => {
    const { resetPasswordData, handleChange, showPassword, setShowPassword, HandleResetPassword, error } = useResetPassword();
    return (
        <>
            <BackgroundCarousel />
            <form onSubmit={HandleResetPassword} className="login-form" style={{top:"25%"}}>
                <h3 className="login-text ">Reset Password</h3>
                <div className="input-set my-2 mx-0">
                    <label>Temporary Password</label>
                    <div className="position-relative">
                        <input
                            value={resetPasswordData.old_password}
                            onChange={handleChange}
                            type={showPassword?.old_password ? "text" : "password"}
                            name="old_password"
                            className="w100"
                            placeholder="Enter Temporary Password"
                        />
                        <InputAdornment position="end">
                            <IconButton
                                style={{ position: "absolute", top: "14px", right: "10px" }}
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword({ ...showPassword, "old_password": !showPassword?.old_password })}
                            >
                                {showPassword?.old_password ? (
                                    <FontAwesomeIcon icon="fa-solid fa-eye-slash" />
                                ) : (
                                    <FontAwesomeIcon icon="fa-solid fa-eye" />
                                )}
                            </IconButton>
                        </InputAdornment>
                    </div>

                    <p className='text-danger text-left mb-1'>{error?.old_password}</p>
                </div>
                <div className="input-set my-2 mx-0">
                    <label>New Password</label>
                    <div className="position-relative">
                        <input
                            value={resetPasswordData?.new_password}
                            onChange={handleChange}
                            type={showPassword?.new_password ? "text" : "password"}
                            name="new_password"
                            className="w100"
                            placeholder="Enter New Password"
                        />
                        <InputAdornment position="end">
                            <IconButton
                                style={{ position: "absolute", top: "14px", right: "10px" }}
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword({ ...showPassword, "new_password": !showPassword?.new_password })}
                            >
                                {showPassword?.new_password ? (
                                    <FontAwesomeIcon icon="fa-solid fa-eye-slash" />
                                ) : (
                                    <FontAwesomeIcon icon="fa-solid fa-eye" />
                                )}
                            </IconButton>
                        </InputAdornment>
                        <p className='text-danger text-left mb-1'>{error?.new_password}</p>
                    </div>

                </div>
                <div className="input-set my-2 mx-0">
                    <label htmlFor="login-password">Confirm Password</label>
                    <div className="position-relative">
                        <input
                            value={resetPasswordData?.conform_password}
                            onChange={handleChange}
                            type={showPassword?.conform_password ? "text" : "password"}
                            className="w100"
                            name="conform_password"
                            placeholder="Enter Confirm Password"
                        />
                        <InputAdornment position="end">
                            <IconButton
                                style={{ position: "absolute", top: "14px", right: "10px" }}
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword({ ...showPassword, "conform_password": !showPassword?.conform_password })}
                            >
                                {showPassword?.conform_password ? (
                                    <FontAwesomeIcon icon="fa-solid fa-eye-slash" />
                                ) : (
                                    <FontAwesomeIcon icon="fa-solid fa-eye" />
                                )}
                            </IconButton>
                        </InputAdornment>
                        <p className='text-danger text-left mb-1'>{error?.conform_password}</p>
                    </div>
                </div>
                <Button
                    type="submit"
                    variant="contained"
                    className="login-button mt-2"
                >
                    Reset <FontAwesomeIcon icon="fa-solid fa-arrow-right btn-icon" />
                </Button>
                {error?.apiError && <p className='text-danger text-center font-weight-bold' >{error?.apiError}</p>}
            </form>
        </>
    );
};

export default Resetpass;
